import BaseService from './baseService'
import EndPoints from '@/constants/dxApiEndpoints'

import {
  BusinessProfile,
  BusinessProfileSettings
} from '@/types/businessProfile'

class BusinessProfileService extends BaseService {
  getPortalBusinessProfiles = async (
    userId: number | undefined,
    protalId: number,
    isRoimatic = false
  ): Promise<BusinessProfile[]> => {
    const response: {
      data: BusinessProfile[]
    } = await this.apiClient.get(EndPoints.PortalsBusinessProfile(protalId), {
      userId: userId,
      isRoimatic: isRoimatic
    })
    let businessProfiles = response.data
    // Get unique profiles (There will be duplicates when a portal admin is accessing it)
    businessProfiles = [
      ...new Map(
        businessProfiles.map((bp: BusinessProfile) => [bp.id, bp])
      ).values()
    ]
    return businessProfiles
  }
  async getUserBusinessProfiles(
    portalId: number | undefined,
    userId: number | undefined,
    isRoimatic: boolean | null = null
  ): Promise<BusinessProfile[]> {
    const response: {
      data: BusinessProfile[]
    } = await this.apiClient.get(
      EndPoints.PortalUserBusinessProfiles(portalId, userId),
      {
        isRoimatic
      }
    )

    let businessProfiles = response.data
    // Get unique profiles (There will be duplicates when a portal admin is accessing it)
    businessProfiles = [
      ...new Map(
        businessProfiles.map((bp: BusinessProfile) => [bp.id, bp])
      ).values()
    ]
    return businessProfiles
  }
  async getBusinessProfileSettings(
    businessProfileId: number,
    keyprefixes?: string,
    includeInternal = true
  ): Promise<BusinessProfileSettings[]> {
    const response: { data: BusinessProfileSettings[] } =
      await this.apiClient.get(
        EndPoints.BusinessProfileSettings(businessProfileId),
        {
          keyprefixes,
          includeInternal
        }
      )
    return response.data
  }
}

export default BusinessProfileService
